import React, { } from "react";
import BrandComponents from "../Brand/BrandComponents";

function CustomerTable() {

  let header = [
    { label: "Id", field: "id" },
    { label: "Company Name", field: "companyname" },
    { label: "Contact Person", field: "contactperson" },
    { label: "Contact No.", field: "contactno" },
    { label: "Email", field: "email" },
    { label: "GST No.", field: "gstno" },


  ];

  return (
    <div>
      <BrandComponents
        header={header}
        tableTitle={"CUSTOMER"}
        apiField={"customer"}
        addButton={"+ ADD"}
        createRoute={"/customerCreate"}
        updateRoute={"/customerView"}
        viewRoute={"/customerView"}
      />
    </div>
  );
}

export default CustomerTable;
